export const MACROTREND = 'macrotrend'
export const MEGATREND = 'megatrend'
export const MICROTREND = 'microtrend'

export const TYPES = [MICROTREND, MACROTREND, MEGATREND]
